export const getUsersSettings = resp => {
  return {
    type: "FETCH_USERS_SETTINGS",
    payload: resp
  };
};

export const saveUsers = resp => {
  return {
    type: "SAVE_USERS",
    payload: resp
  };
};

export const updateUsers = payload => {
  return {
    type: "UPDATE_USERS",
    payload
  };
};

export const initSaveUsers = () => {
  return {
    type: "INIT_SAVE_USERS"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/authorizations.js